<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="$options.titleText"
    :action="onSubmit"
  >
    <v-overlay :value="isLoading" absolute color="white">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </v-overlay>

    <template v-if="!successMessage">
      Вы уверены, что хотите удалить экспертов первого уровня,
      их оценки и комментарии во всех формах этого мероприятия?
      После удаления информации её невозможно будет восстановить.
    </template>

    <div v-if="successMessage" v-html="successMessage" />

    <div
      v-else-if="errorMessage"
      class="error--text ml-8"
      v-text="errorMessage"
    />
  </BModalConfirm>
</template>

<script>
import { MunMehApi } from '@/api/resources'
import { getErrorMessages } from '@/helpers/getErrorMessages'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'

export const SUCCESS_MESSAGE = 'Эксперты первого уровня и их оценки удалены.'

export default {
  name: 'PublicationMunMehDeleteExpert1Modal',
  components: {
    BModalConfirm,
  },
  titleText: 'Удаление экспертов',
  props: {
    munMehId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    successMessage: null,
    errorMessage: null,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close(...args) {
      return this.$refs.modal.close(...args)
    },
    async onSubmit() {
      const api = new MunMehApi()
      try {
        await api.deleteExpert1(this.munMehId, {})
        this.successMessage = SUCCESS_MESSAGE
      } catch (e) {
        this.errorMessage = getErrorMessages(e).join(', ')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
